<template>
  <div>
    <div class="p-6 pt-6">
      <div v-if="!cart" class="px-4 xl:px-[15%]">
        <div class="flex w-full xl:inline-flex xl:items-center flex-col justify-between xl:flex-row  gap-8 bg-white rounded-lg shadow px-4 py-3 relative">
          <DatePicker ref="datepicker" class="w-[40%]" v-model="filter.dates" is-range is24hr :minute-increment="60" mode="date" :min-date="new Date()">
            <template #default="{ inputValue, inputEvents }">
              <div class="text-sm text-gray-700 font-semibold">{{ i18n.t('marketplace.general.when') }}</div>
              <div class="flex items-center gap-1">
                <input class="border-0 text-sm focus:ring-0 focus:border-0 focus:outline-none w-[75px]" :placeholder="i18n.t('marketplace.welcome.anytime')" :value="inputValue.start" v-on="inputEvents.start" />
                <span v-if="filter.dates.end" class="inline-block h-5 leading-5">-</span>
                <input class="border-0 text-sm focus:ring-0 focus:border-0 focus:outline-none w-[75px]"  :value="inputValue.end" v-on="inputEvents.end" />
              </div>
            </template>
          </DatePicker>
          <input type="text" class="jt-input marketplace-input w-full xl:w-auto flex-grow" :placeholder="i18n.t('marketplace.general.search_products')" v-model="filter.query" />
          <button @click="applyFilter()" class="jt-btn">
            {{ i18n.t('marketplace.general.search')  }}
          </button>
        </div>
      </div>
      <div class="px-4 xl:px-[15%]">
        <div class="flex items-center gap-4 flex-col xl:flex-row pt-2 xl:pt-0 ">
          <div v-if="false" class="flex items-center gap-1 bg-gray-100 rounded-lg font-bold text-sm grow xl:grow-0 w-full xl:w-auto">
            <div class="py-3 px-4 rounded-lg text-gray-500 cursor-pointer grow text-center"
                  @click="filter.mode = 'rentals'; applyFilter()"
                :class="{'bg-white !text-black shadow': filter.mode == 'rentals'}">
              {{ i18n.t('marketplace.items_index.rentals') }}
                </div>
            <div class="py-3 px-4 rounded-lg text-gray-500 cursor-pointer grow text-center"
                  @click="filter.mode = 'experiences'; applyFilter()"
                :class="{'bg-white !text-black shadow': filter.mode == 'experiences'}">{{ i18n.t('marketplace.items_index.experiences') }}</div>
          </div>
          <CategoriesSelector v-if="categories.length > 0" :categories="categories" :selectedCategory="filter.category" class="w-full xl:w-auto grow" @select="changeCategory" />
          <div v-else class="flex w-full items-center justify-center h-16">
            <i class="fas fa-spinner fa-spin text-2xl"></i>
          </div>
        </div>
        <hr  v-if="subCategories">
        <SubCategoriesSelector v-if="subCategories" :sub_categories="subCategories" :selectedSubCategory="filter.sub_category" @select="changeSubCategory" />
      </div>
      <div class="px-4 xl:px-[15%] grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4">
        <ItemElement v-for="item in items" :key="item.id" :item="item" :shopProfile="shopProfile" />
        <template v-if="pageLoading">
          <div v-for="n in 16" class="animate-pulse flex flex-col gap-2">
            <div class="bg-white aspect-square w-full relative rounded-lg "></div>
            <div class="flex gap-2">
              <div class="bg-white w-full h-8 rounded-lg"></div>
              <div class="bg-white w-16 h-4 rounded-lg"></div>
            </div>  
            <div class="flex gap-2 justify-end">
              <div class="bg-white w-24 h-6 rounded-lg"></div>
            </div>  
          </div>
        </template>
      </div>
      <div v-if="items.length == 0 && !pageLoading" class="text-center w-full pt-16 text-gray-500">
        {{ i18n.t('general.no_items') }}
      </div>
     
    </div>
  </div>
</template>

<script>
  import axios from '../../shared/custom_axios.js';
  import ItemElement from './item.vue'
  import CategoriesSelector from './categories_selector.vue'
  import SubCategoriesSelector from './sub_categories_selector.vue'
  import LoadingOverlay from '../../shared/loading_overlay.vue'
  import DatePicker from 'v-calendar/lib/components/date-picker.umd'
  import FilterScreen from './filter_screen.vue'
  import Treeselect from '@riophae/vue-treeselect';

  export default {
    name: 'ItemsContainer',
    props: {
      itemsUrl: String,
      categoriesUrl: String,
      subCategoriesUrl: String,
      locationsUrl: String,
      referral: String,
      countriesUrl: String,
      regionsUrl: String,
      shopProfile: String,
      resetFilters: Boolean,
      country: String,
      city: String,
      mapUrl: String,
      profileId: String,
      profileName: String
    },
    components: {
      ItemElement,
      LoadingOverlay,
      DatePicker,
      CategoriesSelector,
      FilterScreen,
      Treeselect,
      SubCategoriesSelector
    },
    data: function() {
      return {
        items: [],
        nextPageUrl: null,
        lastPage: false,
        pageLoading: false,
        categories: [],
        subCategories: null,
        locations: [],
        cartNumberExist: false,
        cart: null,
        filter: {
          category: null,
          sub_category: null,
          country: null,
          city: null,
          query: null,
          mode: 'rentals',
          dates: {
            start: null,
            end: null
          }
         },
        showFilter: false
      }
    },
    created() {
      if (this.resetFilters) {
        localStorage.removeItem(this.filterName)
      }

      let filter = localStorage.getItem(this.filterName);

      let filterTimestamp = localStorage.getItem('filterTimestamp');

      if (filterTimestamp) {
        let now = new Date().getTime();
        let diff = now - filterTimestamp;
        if (diff > 1000 * 60 * 60) {
          localStorage.removeItem(this.filterName);
          localStorage.removeItem('filterTimestamp');
          filter = null;
        }
      }

      
      if (filter) {
        let parsedFilter = JSON.parse(filter);
        if (this.country && this.city) {
          parsedFilter.country = this.country;
          parsedFilter.city = this.city;
        }
        if (this.profileId) {
          parsedFilter.profile_id = this.profileId;
          parsedFilter.profile_name = this.profileName;
        }
        this.filter = parsedFilter;
      } else {
        if (this.country && this.city) {
          this.filter = {
            profile_id: this.profileId,
            profile_name: this.profileName,
            category: null,
            sub_category: null,
            query: null,
            mode: 'rentals',
            country: this.country || '',
            city: this.city || '',
            dates: {
              start: null,
              end: null
            }
          }
        }
      }
    },
    mounted() {
      this.syncCart();

      if (!this.landingPageView) {
        this.getCategories();
      }

      window.addEventListener('scroll', this.handleScroll)
      if (this.referral) {
        window.referralCode = this.referral;
        localStorage.setItem('referralCode', this.referral);
      }
    },
    watch: {
      filter: {
        handler: function() {
          localStorage.setItem('filterTimestamp', new Date().getTime());
          localStorage.setItem(this.filterName, JSON.stringify(this.filter));
        },
        deep: true
      },
      landingPageView() {
        if (!this.landingPageView) {
          this.getCategories();
        }
      }
    },
    computed: {
      filterName() {
        return 'MarketplaceFilter' + (this.shopProfile || '');
      },
      activeFilters() {
        return {
          category: this.filter.category || '',
          sub_category: this.filter.sub_category || '',
          country: this.filter.country || '',
          city: this.filter.city || '',
          profile_id: this.filter.profile_id || '',
          start_date: this.toISOString(this.filter.dates?.start),
          end_date: this.toISOString(this.filter.dates?.end),
          query: this.filter.query || '',
          mode: this.filter.mode || 'rentals'
        }
      },
      mapUrlWithLocation() {
        return this.mapUrl + '?country=' + this.filter.country + '&city=' + this.filter.city;
      },
      selectedCategory() {
        return this.categories.find(category => category.id == this.filter.category);
      },
      landingPageView() {
        return (!this.filter.country || !this.filter.city || this.showFilter) && !this.shopProfile
      }
    },
    beforeUnmount() {
      window.removeEventListener('scroll', this.handleScroll)
    },
    destroyed() {
      this.items = []
    },
    methods: {
      toISOString(date) {
        if (!date) return '';
        if (typeof date == 'string') date = new Date(date);

        return date.toISOString();
      },
      applyFilter(filter = null) {
        if (filter) {
          this.filter = filter;
          this.showFilter = false;
        }

        if (this.filter.category) {
          this.resetItems();
          this.getSubCategories();
        }

      },
      changeCategory(category) {
        this.filter.category = category;
        this.filter.sub_category = null;
        this.subCategories = null;
        this.getSubCategories();
        this.applyFilter();
      },
      changeSubCategory(subCategory) {
        this.filter.sub_category = subCategory;
        this.applyFilter();
      },
      resetItems() {
        this.items = [];
        this.nextPageUrl = null;
        this.lastPage = false;
        this.getItems();
      },
      prepareParams() {
        let params = {}

        if (this.cart) {
          params.shop= this.cart.attributes.profile_id
        }

        params = { ...params, ...this.activeFilters }
        return params;
      },
      getItems() {
        if (this.pageLoading) {
          return;
        }
        let url = this.nextPageUrl ? this.nextPageUrl : this.itemsUrl;
        this.pageLoading = true;
        let params = this.prepareParams();
        axios.get(url, {params: params})
          .then(response => {
            this.pageLoading = false;
            this.items = [...this.items, ...response.data.data];
            this.nextPageUrl = response.data.links.next_page;
            this.lastPage = response.data.links.last_page;
          })
      },
      getCategories() {
        let params = this.prepareParams();
        params['category'] = '';
        this.categories = [];
        axios.get(this.categoriesUrl, {params: params})
          .then(response => {
            this.categories = response.data;
            this.applyFilter();
          })
      },
      getSubCategories() {
        if (!this.filter.category) return;

        let params = this.prepareParams();
        params['sub_category'] = '';
        axios.get(this.subCategoriesUrl, {params: params})
          .then(response => {
            this.subCategories = response.data
          })
      },
      getLocations() {
        fetch(this.locationsUrl)
          .then(response => response.json())
          .then(data => {
            this.locations = data;
          })
      },
      prepareUrl(url, preview = false) {
        let newUrl = url;
        let filters = this.activeFilters;
        if (preview) {
          newUrl += 'category=' + preview.id+ '&per_page=4&';
          delete filters.category;
          delete filters.sub_category;
        }

        if (this.cart && !this.shopProfile) {
          newUrl += 'shop=' + this.cart.attributes.profile_id + '&'
        }
        newUrl += new URLSearchParams(filters);
        return newUrl;
      },
      handleScroll() {
        if (!this.lastPage && (window.innerHeight + window.scrollY) >= document.body.offsetHeight - 100) {
          if (this.filter.category) this.getItems();
        }
      },
      syncCart: function() {
        this.cart = window.activeCart;

        setTimeout(() => {
          this.syncCart();
        }, 100);
      },
      clearProfileSelection() {
        this.filter.profile_id = null;
        this.filter.profile_name = null;
        this.resetItems();
      },
      formatDateTime(date) {
        if (typeof date == 'string') {
          date = new Date(date);
        }

        if (!date) return null;

        let hours = date.getHours();
        let minutes = date.getMinutes();
        if (minutes < 10) {
          minutes = '0' + minutes;
        }
        if (hours < 10) {
          hours = '0' + hours;
        }
        return `${date.getDate()} ${date.toLocaleString('default', { month: 'short' })} ${hours}:${minutes}`
      }
    }
  }
</script>
